import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { getFormattedNumber } from '@ecg-marktplaats/aurora-js-formatters';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import Classes from './LocationIntroText.module.scss';

interface LocationIntroTextProps {
  cityName: string;
  resultCount: number | null;
  cityIntroText?: string;
}

const containerClassName = getSuitCSSClasses({ namespace: 'hz', name: 'LocationIntroText' });

const LocationIntroText = ({ cityName, resultCount, cityIntroText }: LocationIntroTextProps) => {
  const { t } = useI18nContext();
  const [expanded, setExpanded] = useState(false);

  const displayLocation = cityName;

  const sharedEnding = t('cars.location.intro.shared_ending', { location: displayLocation });
  const introText = cityIntroText
    ? `${cityIntroText} ${sharedEnding}`
    : t('cars.location.intro.fallback', { location: displayLocation });

  return (
    <div className={containerClassName}>
      <h1 className={Classes.h1}>{t('cars.location.h1', { location: displayLocation })}</h1>
      {resultCount !== null && (
        <p className={Classes.resultCount}>
          {t('cars.location.result_count', { count: resultCount, formattedCount: getFormattedNumber(resultCount) })}
        </p>
      )}
      <div className={`${Classes.introText} ${expanded ? Classes.expanded : ''}`}>
        <span>{introText}</span>
      </div>
      <button className={Classes.readMore} aria-expanded={expanded} onClick={() => setExpanded(!expanded)}>
        {expanded ? t('cars.location.read_less') : t('cars.location.read_more')}
      </button>
    </div>
  );
};

export default LocationIntroText;
